import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { RequestRepo } from "./repository/request.repo";
import { RequestFormAdapter } from "./request.adapter";
import { RequestController } from "./request.controller";
import { RequestService } from "./request.service";
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { VisitorRepo } from "./repository/security.repo";
import { VisitorAdapter } from "./security.adapter";
import { WhatsAppNotificationService } from "@gtpl/shared-services/notification-management";

@Module({
    imports: [TypeOrmModule.forFeature([RequestRepo,VisitorRepo])],
    controllers: [RequestController],
    providers: [RequestService, RequestFormAdapter, ApplicationExceptionHandler,WhatsappBroadCastService,VisitorAdapter,WhatsAppNotificationService],
    exports: [RequestService, TypeOrmModule]
})

export class RequestModule {}